import { ClientTask } from 'graphql-query-contracts';

import { convertTeamToID } from './convertTeamToID';

export const convertTask = (task: ClientTask) => {
  return {
    ...task,
    assignee: task?.assignee?._id,
    assigneeGroup: convertTeamToID(task?.assigneeGroup || []),
    status: task?.status || '',
  };
};
